type ReadyCallback = () => void | Promise<void>

const callbacks: ReadyCallback[] = []
let isReady = false

function tryAndCatch(callback: ReadyCallback) {
  try {
    Promise.resolve(callback()).catch(function (error) {
      console.error(error)
    })
  } catch (error) {
    console.error(error)
  }
}

/**
 * Triggered when document is ready
 */
function ready() {
  isReady = true
  callbacks.forEach((cb) => tryAndCatch(cb))
}

/**
 * Register a function to run when document is ready
 */
export function onDocumentReady(callback: ReadyCallback) {
  if (isReady) {
    tryAndCatch(callback)
  } else {
    callbacks.push(callback)
  }
}

function handler() {
  ready()
  document.removeEventListener("DOMContentLoaded", handler)
}

// Based on jquery's `$(document).ready`
// if the ready state is not loading, `DOMContentLoader` has already fired so trigger ready
// else setup the listener to run once it is loaded
if (document.readyState !== "loading") {
  ready()
} else {
  document.addEventListener("DOMContentLoaded", handler)
}
